module.exports = __webpack_public_path__ + "static/img/03.7b74d25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/03.jpg
// module id = 418
// module chunks = 1